<!-- Chat Component -->
<div class="chat-container"
     #chatContainer
     [class.floating-panel-mode]="inFloatingPanel"
    [class.full-page-layout]="fullPageLayout"
    [style.--chat-full-page-max-width]="fullPageContentMaxWidth + 'px'"
    [style.--chat-full-page-content-padding-start]="fullPageContentPaddingStart + 'px'"
    [style.--chat-full-page-content-padding-end]="fullPageContentPaddingEnd + 'px'"
    [style.--chat-full-page-content-mobile-padding-start]="fullPageContentMobilePaddingStart + 'px'"
    [style.--chat-full-page-content-mobile-padding-end]="fullPageContentMobilePaddingEnd + 'px'"
    [style.--chat-footer-padding-bottom]="footerBottomPadding + 'px'"
    [style.--chat-footer-mobile-padding-bottom]="footerBottomPadding + 'px'"
    [style.--chat-footer-shell-padding-start]="footerShellPaddingStart + 'px'"
    [style.--chat-footer-shell-padding-end]="footerShellPaddingEnd + 'px'"
    [style.--chat-footer-shell-mobile-padding-start]="footerShellMobilePaddingStart + 'px'"
    [style.--chat-footer-shell-mobile-padding-end]="footerShellMobilePaddingEnd + 'px'"
    [style.--chat-footer-inline-padding]="footerInlinePadding + 'px'"
    [style.--chat-footer-mobile-inline-padding]="footerMobileInlinePadding + 'px'"
    [style.--thread-todo-top.px]="threadTodoPopoverTop"
    [style.--thread-todo-right.px]="threadTodoPopoverRight"
    [style.--thread-todo-width.px]="threadTodoPopoverWidth"
     [class.drag-over]="isDragOver"
     (click)="closePopovers()"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)">
     
    <!-- Drag overlay -->
    <div class="drag-overlay" *ngIf="isDragOver">
        <div class="drag-overlay-content">
            <i class="fas fa-file-import fa-3x mb-3"></i>
            <div class="drag-overlay-text">Drop images or context to attach</div>
        </div>
    </div>
     
    <!-- Scrollable Content Area -->
    <div class="chat-scrollable-content"
         #scrollableContent
         [class.scroll-pending]="initialScrollPending">
        <div class="chat-scrollable-content__inner"
             #scrollableContentInner
             [class.chat-scrollable-content__inner--constrained]="fullPageLayout">
            <!-- Chat Messages Area -->
            <app-chat-messages-area 
                #chatMessages 
                [history]="history"
                [currentThreadId]="currentThreadId"
                [currentThread]="currentThread"
                [loading]="loading"
                [backendUrl]="backendUrl"
                [backendEnvironment]="backendEnvironment"
                [availableModels]="availableModels"
                [displayMode]="displayMode"
                [renderPreviewsInline]="renderPreviewsInline"
                [requestedDetachedPreviewKind]="requestedDetachedPreviewKind"
                [requestedDetachedPreviewId]="requestedDetachedPreviewId"
                [previewPresentation]="previewPresentation"
                [parseMarkdown]="parseMarkdown"
                (deleteMessage)="onDeleteMessage($event)"
                (updateMessage)="onUpdateMessage($event)"
                (deviceCommandRequested)="onDeviceCommandRequested($event)"
                (previewOutletChange)="onPreviewOutletChanged($event)"
                (threadAssetsChanged)="onThreadAssetsChanged($event)"
                (suggestedFollowUpSelected)="onSuggestedFollowUpSelected($event)">
            </app-chat-messages-area>
            
            <!-- Thread Status Component (replaces loading indicator) -->
            <app-thread-status 
                *ngIf="displayMode !== 'minimal'"
                [currentThread]="currentThread"
                [loading]="loading"
                [agent]="agent">
            </app-thread-status>
        </div>
    </div>

    <div class="thread-todo-popover-anchor"
         *ngIf="shouldShowThreadTodoPopover">
        <app-thread-todo-popover
            [todoList]="currentThread?.todoList"
            [lightTheme]="theme.isLight"
            [defaultExpanded]="threadTodoPopoverDefaultExpanded"
            [debugMode]="displayMode === 'debug'"
            (editTodoItem)="onEditTodoItemRequested($event)"
            (deleteTodoItem)="onDeleteTodoItemRequested($event)"
            (resetTodoList)="onResetTodoListRequested()">
        </app-thread-todo-popover>
    </div>

    <!-- Welcome State -->
    <div class="chat-centered-block" [class.chat-centered-block--constrained]="fullPageLayout">
        <app-welcome-state
            *ngIf="!currentThreadId && !loading"
            [currentThreadId]="currentThreadId"
            [loading]="loading"
            [inFloatingPanel]="inFloatingPanel || false"
            [contextUserObject]="contextUserObject"
            (shortcutDemonstrated)="onShortcutDemonstrated($event)"
            (starterPromptClicked)="onStarterPromptClick($event)">
        </app-welcome-state>
    </div>

    <!-- Thread Loading State -->
    <div class="thread-loading-overlay" *ngIf="isLoadingThread" role="status" aria-live="polite">
        <div class="loading-state loading-state--thread">
            <div class="loading-content">
                <div class="loading-spinner"></div>
                <span>Loading conversation...</span>
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div class="chat-centered-block" [class.chat-centered-block--constrained]="fullPageLayout" *ngIf="!currentThreadId && loading && !isLoadingThread">
        <div class="loading-state">
            <div class="loading-content">
                <div class="loading-spinner"></div>
                <span>Initializing...</span>
            </div>
        </div>
    </div>

    <!-- Chat Input Footer -->
    <div class="chat-footer">
        <div class="chat-footer__inner" [class.chat-footer__inner--constrained]="fullPageLayout">
            <div class="input-wrapper" #inputWrapper (click)="$event.stopPropagation()">
                <app-input-container
                [isExpanded]="isExpanded"
                [newMessage]="newMessage"
                [loading]="loading"
                [initializingThread]="initializingThread"
                [isRecording]="isRecording"
                [isConnecting]="isConnecting"
                [isProcessingTranscription]="isProcessingTranscription"
                [showTranscriptionCancel]="showTranscriptionCancel"
                [autofocusOnLoad]="autofocusOnLoad || false"
                [agent]="agent"
                [messageCount]="history.length"
                [hasAttachedContext]="attachedContextItems.length > 0"
                [attachedItems]="attachedContextItems"
                [attachedImageItems]="attachedImageItems"
                [attachedFileItems]="attachedFileItems"
                [imageAttachmentsSupported]="selectedModelSupportsImages"
                [currentMode]="mode"
                [currentModelLabel]="selectedModel?.displayName || ''"
                [currentModelKey]="selectedModel?.key || ''"
                [availableTools]="availableTools"
                [selectedToolNames]="selectedToolNames"
                [defaultToolNames]="defaultToolNames"
                [currentAudioModelKey]="selectedAudioModelKey"
                [currentImageModelKey]="selectedImageModelKey"
                [currentVideoModelKey]="selectedVideoModelKey"
                [currentAudioVoice]="selectedAudioVoice"
                [currentThread]="currentThread"
                [currentThreadId]="currentThreadId"
                [threadMessages]="history"
                [viewOptions]="viewOptions"
                [currentDisplayMode]="displayMode"
                [renderPreviewsInline]="renderPreviewsInline"
                [isLocalDevelopment]="isLocalDevelopment"
                [useLocalBackend]="useLocalBackend"
                [hostedBackendLabel]="hostedBackendLabel"
                [forceCompactionLoading]="forceCompactionLoading"
                [threadAssetItems]="threadAssetItems"
                [availableModels]="availableModels"
                [availableVideoModels]="availableVideoModels"
                [defaultAudioModelKey]="defaultAudioModelKey"
                [defaultAudioVoice]="defaultAudioVoice"
                [defaultImageModelKey]="defaultImageModelKey"
                [defaultVideoModelKey]="defaultVideoModelKey"
                [audioVoiceOptionsByModel]="audioVoiceOptionsByModel"
                [providerRecommendations]="providerRecommendations"
                [modelCatalogStatus]="modelCatalogStatus"
                [modelCatalogSourceLabel]="modelCatalogSourceLabel"
                [modelCatalogMessage]="modelCatalogMessage"
                [toolCatalogStatus]="toolCatalogStatus"
                [toolCatalogSourceLabel]="toolCatalogSourceLabel"
                [toolCatalogMessage]="toolCatalogMessage"
                [suggestionsPlacement]="composerSuggestionsPlacement"
                [contextUid]="contextUid || ''"
                [agencyId]="effectiveAgencyId"
                [remainingCredits]="remainingCredits"
                [creditBalanceLoading]="creditBalanceLoading"
                (messageChanged)="onMessageChanged($event)"
                (messageSent)="sendMessage()"
                (addCreditsRequested)="openAddCreditsModal()"
                (creditsPageRequested)="goToAgencyCredits()"
                (microphoneToggled)="toggleMicrophone()"
                (textareaKeyDown)="onTextareaKeyDownEvent($event)"
                (removeAttachedContext)="onRemoveAttachedContext($event)"
                (transcriptionCancelled)="onTranscriptionCancelled()"
                (agentChanged)="onAgentChangedFromComposer($event)"
                (modeChanged)="onModeChangedFromComposer($event)"
                (modelChanged)="onModelChangedFromComposer($event)"
                (toolSelectionChanged)="onToolSelectionChangedFromComposer($event)"
                (audioModelChanged)="onAudioModelChangedFromComposer($event)"
                (imageModelChanged)="onImageModelChangedFromComposer($event)"
                (videoModelChanged)="onVideoModelChangedFromComposer($event)"
                (audioVoiceChanged)="onAudioVoiceChangedFromComposer($event)"
                (modelChipClicked)="onModelCatalogRefreshRequested()"
                (toolSelectorOpened)="onToolCatalogRefreshRequested()"
                (playbookActivated)="onPlaybookActivated($event)"
                (playbookSubmitted)="onPlaybookSubmitted($event)"
                (contextItemSelected)="selectContextItem($event)"
                (businessSelectedForContext)="onBusinessSelectedForContext($event)"
                (businessAttachedForContext)="onBusinessAttachedForContext($event)"
                (viewOptionSelected)="onViewOptionSelected($event)"
                (displayModePreferenceChanged)="onDisplayModePreferenceChanged($event)"
                (renderPreviewsInlinePreferenceChanged)="onRenderPreviewsInlinePreferenceChanged($event)"
                (backendPreferenceChanged)="onBackendToggled($event)"
                (threadAssetSelected)="onThreadAssetSelected($event)"
                (renameThreadRequested)="onRenameCurrentThreadRequested($event)"
                (newConversationRequested)="onCreateNewThread()"
                (deleteThreadRequested)="onDeleteCurrentThreadRequested()"
                (forceCompactionRequested)="onForceCompactionRequested()"
                (selectorModalClosed)="closePopovers()">
                </app-input-container>
            </div>
        </div>
    </div>
</div>

<ng-template #threadDeleteProgressTemplate>
    <div class="thread-delete-progress"
         [class.thread-delete-progress--light]="theme.isLight"
         *ngIf="isDeletingThread">
        <div class="thread-delete-progress__spinner" aria-hidden="true">
            <i class="fa-solid fa-circle-notch fa-spin"></i>
        </div>

        <div class="thread-delete-progress__status">{{ threadDeletionStatusLabel }}</div>
        <div class="thread-delete-progress__detail">{{ threadDeletionStatusDetail }}</div>

        <div class="thread-delete-progress__meter" aria-hidden="true">
            <span class="thread-delete-progress__meter-fill" [style.width.%]="threadDeletionProgressPercent"></span>
        </div>

        <div class="thread-delete-progress__count" *ngIf="hasThreadDeletionCount">
            {{ threadDeletionProcessedCount }} / {{ threadDeletionTotalCount }} messages removed
        </div>
    </div>
</ng-template>

<ng-template #addCreditsModalBody>
    <div class="credit-top-up-modal">
        <div class="credit-top-up-balance-grid" aria-label="Credit balance">
            <ui-card class="credit-top-up-balance-card" variant="bordered" surface="soft" size="sm">
                <ui-text variant="body" heading="Remaining" [description]="formatCredits(remainingCredits || 0)"></ui-text>
            </ui-card>
            <ui-card class="credit-top-up-balance-card" variant="bordered" surface="soft" size="sm">
                <ui-text variant="body" heading="Used this month" [description]="formatCredits(usedCredits)"></ui-text>
            </ui-card>
        </div>

        <ui-text class="credit-top-up-section-heading" variant="section" heading="Package"></ui-text>

        <div class="credit-top-up-options" aria-label="Credit packages">
            <ui-card
                *ngFor="let option of creditTopUpOptions"
                class="credit-top-up-option"
                variant="bordered"
                surface="soft"
                size="sm"
                layout="item"
                [clickable]="true"
                [selectable]="true"
                [selected]="selectedCreditTopUpCredits === option.credits"
                [attr.aria-pressed]="selectedCreditTopUpCredits === option.credits"
                [attr.aria-label]="formatCredits(option.credits) + ' credits for $' + option.priceUsd"
                (cardClick)="selectCreditTopUp(option)">
                <ng-template #cardTitle>{{ formatCredits(option.credits) }} credits</ng-template>
                <ng-template #cardTrailing>
                    <span class="credit-top-up-option__price">${{ option.priceUsd }}</span>
                    <i *ngIf="selectedCreditTopUpCredits === option.credits" class="fa-solid fa-check credit-top-up-option__check" aria-hidden="true"></i>
                </ng-template>
            </ui-card>
        </div>

        <div class="credit-top-up-note" *ngIf="!isLoadingCreditTopUpCards && creditTopUpCardCount === 0">
            <ui-text variant="body" description="Select a package, then add a card to continue."></ui-text>
            <ui-button variant="clear" color="primary" size="sm" customClass="credit-top-up-inline-action" (buttonClick)="goToAgencyPricing()">View plans</ui-button>
        </div>

        <ui-text class="credit-top-up-note" *ngIf="!isLoadingCreditTopUpCards && creditTopUpCardCount > 0" variant="body" description="Credits are added now. Billing uses the saved agency card."></ui-text>

        <ui-card class="credit-top-up-card-state" variant="bordered" surface="soft" size="sm" *ngIf="isLoadingCreditTopUpCards" aria-live="polite">
            <ui-spinner text="Checking agency card..." size="sm" [showText]="true"></ui-spinner>
        </ui-card>

        <ui-card class="credit-top-up-card-state credit-top-up-card-state--ready" variant="bordered" surface="soft" size="sm" layout="item" icon="fa-regular fa-credit-card" *ngIf="!isLoadingCreditTopUpCards && creditTopUpCardCount > 0">
            <ng-template #cardTitle>{{ creditTopUpCardLabel || 'Saved card on account' }}</ng-template>
        </ui-card>

        <ui-card class="credit-top-up-card-state credit-top-up-card-state--blocked" variant="bordered" surface="soft" size="sm" layout="item" icon="fa-regular fa-circle-exclamation" *ngIf="!isLoadingCreditTopUpCards && creditTopUpCardCount === 0" role="alert">
            <ng-template #cardTitle>{{ creditTopUpError || 'Add a payment card before adding credits.' }}</ng-template>
        </ui-card>

        <ui-card class="credit-top-up-card-state credit-top-up-card-state--blocked" variant="bordered" surface="soft" size="sm" layout="item" icon="fa-regular fa-circle-exclamation" *ngIf="creditTopUpError && creditTopUpCardCount > 0" role="alert">
            <ng-template #cardTitle>{{ creditTopUpError }}</ng-template>
        </ui-card>
    </div>
</ng-template>

<ng-template #addCreditsModalFooter>
    <div class="credit-top-up-footer">
        <ui-button
            *ngIf="!isLoadingCreditTopUpCards && creditTopUpCardCount === 0"
            variant="filled"
            color="primary"
            size="lg"
            icon="fa-regular fa-credit-card"
            customClass="credit-top-up-footer-action"
            [fullWidth]="true"
            (buttonClick)="goToAgencyCards()">
            Add payment card
        </ui-button>
        <ui-button
            *ngIf="isLoadingCreditTopUpCards"
            variant="filled"
            color="primary"
            size="lg"
            customClass="credit-top-up-footer-action"
            [fullWidth]="true"
            [disabled]="true">
            Checking card...
        </ui-button>
        <ui-button
            *ngIf="!isLoadingCreditTopUpCards && creditTopUpCardCount > 0"
            variant="filled"
            color="primary"
            size="lg"
            [icon]="isAddingCredits ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-bolt'"
            customClass="credit-top-up-footer-action"
            [fullWidth]="true"
            [disabled]="!canAddSelectedCredits"
            (buttonClick)="addSelectedCredits()">
            Add {{ formatCredits(selectedCreditTopUpOption.credits) }} credits
        </ui-button>
    </div>
</ng-template>
